<template>
  <b-overlay
    :show="
      (addItem && addItem.loading && addItem.itemId === item.id && !personalization) ||
      (removeItem.loading && removeItem.itemId === item.id && !personalization)
    "
    rounded="sm"
    variant="white"
  >
    <div v-if="child && personalization" class="child-product product mt-2">
      <hr class="my-1" />
      <b-row
        v-if="child & personalization && item.product"
        no-gutters
        align-v="center"
        class="justify-content-between"
        style="min-height: 40px"
      >
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="auto">
              <span class="fa-layers fa-fw" style="width: 40px">
                <b-img
                  v-if="item.product.image"
                  :src="require('@/assets/tag_icon_grey.png')"
                  alt=""
                  class="fa-stack-2x"
                  width="40px"
                  height="40px"
                  style="opacity: 0.7"
                />
                <fa-icon
                  v-if="!item.customTagOrderInfo"
                  :icon="['far', 'plus-circle']"
                  transform="down-13 right-13 grow-3"
                  class="text-success"
                />
              </span>
            </b-col>
            <b-col class="ml-lg-2" :class="item.customTagOrderInfo ? 'ml-1' : 'ml-2'">
              <h4 v-if="item.customTagOrderInfo" class="m-0">{{ $t('components.product.personalization') }}</h4>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else class="m-0">
                <b-link
                  @click="
                    item.group && item.group.pet && item.group.pet.name ? emitAddChildItem() : (addPersonalization = !addPersonalization)
                  "
                >
                  <span v-if="itemPersonalizationTitle" v-text="itemPersonalizationTitle"></span>
                  <span v-else>
                    {{ $t('components.product.addPersonalization') }}
                    {{ $n(isItemPersonalizationDiscounted ? itemPersonalizationDiscountedPrice : itemPersonalizationPrice, 'currency') }}
                  </span>
                </b-link>
              </component>
              <small v-if="!item.customTagOrderInfo" class="m-0 text-secondary">
                <span v-if="item.group && item.group.pet && item.group.pet.name">{{ item.group.pet.name.substr(0, 9) }}</span>
                <span v-else class="sentry-mask">{{ personalizationName.substr(0, 9) || '[Enter Name]' }}</span> | {{ poPrimaryPhone }}
                <b-collapse id="collapse-4" v-model="addPersonalization" class="mt-1 ml-2">
                  <dp-input
                    id="personalize-name"
                    v-model.trim="personalizationName"
                    name="pet's name"
                    type="text"
                    :placeholder="$t('components.product.input.petName.placeholder')"
                    :validation-rules="{ noEmojis: true, max: 9 }"
                    vid="petName"
                  />
                  <b-link
                    class="btn btn-sm btn-primary w-100 mt-n2 d-flex align-items-center"
                    :disabled="!personalizationName || personalizationLoading"
                    @click="emitAddChildItem"
                  >
                    <div class="mx-auto">{{ $t('dp.buttons.save') }}</div>
                    <div v-if="personalizationLoading" role="status" class="fa-pulse float-right">
                      <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
                      <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
                    </div>
                  </b-link>
                </b-collapse>
              </small>
              <component
                :is="isSmallScreen ? 'h5' : 'h4'"
                v-else-if="item.customTagOrderInfo.name && item.customTagOrderInfo.phone"
                class="m-0 sentry-mask"
              >
                {{ item.customTagOrderInfo.name }} |
                {{ item.customTagOrderInfo.phone }}
              </component>
              <component
                :is="isSmallScreen ? 'h5' : 'h4'"
                v-else-if="item.product.type === 'COLLAR' && item.customTagOrderInfo.phone"
                class="m-0 sentry-mask"
              >
                <span v-if="item.group && item.group.pet && item.group.pet.id"
                  >{{ item.group.pet.name }} [{{ item.group.pet.idCode }}]</span
                >
                <span v-else v-html="$t('components.product.petHomeSafeId')"></span> |
                {{ item.customTagOrderInfo.phone }}
              </component>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="item.product && item.customTagOrderInfo" cols="auto">
          <h3 class="m-0 text-right">
            <span
              v-if="item.product.personalization"
              :style="{
                textDecoration: isItemPersonalizationDiscounted ? 'line-through' : '',
              }"
            >
              {{
                !isItemPersonalizationDiscounted && Number(itemPersonalizationPrice) === 0
                  ? $t('components.totals.free')
                  : $n(itemPersonalizationPrice, 'currency')
              }}
            </span>
            <span v-if="item.product.personalization && isItemPersonalizationDiscounted" class="ml-1">
              <span v-if="itemPersonalizationDiscountedPrice > 0">{{ $n(itemPersonalizationDiscountedPrice, 'currency') }}</span>
              <span v-else>{{ $t('components.totals.free') }}</span>
            </span>
          </h3>
          <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('dp.generic.remove') }}</b-button>
        </b-col>
      </b-row>
    </div>

    <div v-else-if="child && item.product && 'SUBSCRIPTION' === item.product.type" class="child-product">
      <PetTrackingDeviceSubscriptionProduct :item="item" />
    </div>

    <div v-else-if="child && walletCard" class="child-product product mt-2">
      <hr class="my-1" />
      <b-row v-if="item.product" no-gutters align-v="center" class="justify-content-between" style="min-height: 40px">
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-end">
            <b-col cols="auto">
              <b-img v-if="item.id" :src="require('@/assets/paw_card.png')" alt="" width="40px" height="40px" />
            </b-col>
            <b-col class="ml-lg-2 ml-1" :class="isSmallScreen ? 'ml-2' : ''">
              <h4 class="m-0">{{ $t('views.basket.duplicateWalletCard') }}</h4>
            </b-col>
            <b-col cols="12" class="col-md-auto">
              <h3 class="m-0 text-right">
                <span v-if="Number(item.subtotal) !== Number(walletCardPrice)" style="text-decoration: line-through">
                  <span v-if="item.discount === 0">{{ $n(walletCardPrice, 'currency') }}</span>
                  <span v-else>{{ $n(item.subtotal, 'currency') }}</span>
                </span>
                <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                  <span v-if="Number(item.subtotal - item.discount) > 0">
                    {{ $n(item.subtotal - item.discount, 'currency') }}
                  </span>
                </span>
              </h3>
              <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('dp.generic.remove') }}</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div v-else-if="child" class="child-product product" :hidden="!item.product || item.product.name === 'Standard Split Ring'">
      <hr class="my-1" />
      <b-row v-if="item.product" no-gutters align-v="center" class="justify-content-between" style="min-height: 40px">
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="auto" class="mr-1">
              <span class="fa-layers fa-fw" style="width: 40px">
                <b-img
                  v-if="item.product.image"
                  :src="getImage(item.product.image.original)"
                  alt=""
                  class="fa-stack-2x"
                  width="40px"
                  height="40px"
                  style="opacity: 0.7"
                />
                <fa-icon
                  v-if="(orderId && !item.id) || !item.parent"
                  :icon="['far', 'plus-circle']"
                  transform="down-13 right-13 grow-3"
                  class="text-success"
                />
              </span>
            </b-col>
            <b-col class="ml-1 ml-lg-2">
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.id || (!orderId && item.parent)" class="m-0 pl-lg-0">
                <span v-if="!item.keyChain">{{ item.product.name }}</span>
                <span v-else>{{ $t('components.product.matchingKeyChain') }}</span>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.product.type === 'CONNECTOR'" class="m-0">
                <b-link @click="emitAddChildItem">{{ $t('components.product.upgradeTo', {productName: item.product.name }) }} {{ $n(item.product.price, 'currency') }}</b-link>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.product.type === 'PET_ESSENTIALS'" class="m-0 py-2">
                <b-link @click="emitAddChildItem">{{ $t('components.product.glowTag') }} {{ $n(item.product.price, 'currency') }}</b-link>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.keyChain" class="m-0 py-2">
                <b-link @click="emitAddChildItem"
                  >{{ $t('components.product.addMatchingKeyChain') }}
                  {{ $n(item.product.keyChainDiscountedPrice || item.product.keyChainPrice, 'currency') }}
                </b-link>
              </component>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="item.id || (!orderId && item.parent)" cols="auto">
          <h3 class="m-0 text-right">
            <span
              :style="{
                textDecoration:
                  Number(item.product[!item.keyChain ? 'price' : 'keyChainPrice']) !== Number(item.subtotal - item.discount)
                    ? 'line-through'
                    : '',
              }"
            >
              {{ $n(item.product[!item.keyChain ? 'price' : 'keyChainPrice'], 'currency') }}
            </span>
            <span
              v-if="Number(item.product[!item.keyChain ? 'price' : 'keyChainPrice']) !== Number(item.subtotal - item.discount)"
              class="ml-1"
            >
              <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
              <span v-else>{{ $t('components.totals.free') }}</span>
            </span>
          </h3>
          <b-button
            v-if="remove && item.product.sku !== 'FREE_STICKER'"
            variant="link"
            class="m-0 p-0 text-right"
            block
            @click="removeThisItem"
            >{{ $t('dp.generic.remove') }}</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div
      v-else-if="
        ['LICENCE', 'LATE_FEE', 'DONATION', 'REPLACEMENT_TAG'].includes(item.product.type) ||
        vs ||
        noNewTag ||
        (item.product && 'ADDITIONAL_FEE' === item.product.type && 'pet' === item.product.subType)
      "
      class="license-product product pl-0 pr-1"
      :class="{ 'pb-3': last }"
    >
      <b-row no-gutters align-v="center">
        <b-col>
          <h3 class="m-0 pr-2 pl-4">
            <span v-html="tagProductName"></span> {{ vsExpirationDateProductFormat(item.product) }}
            <span v-if="item.quantity > 1">(x{{ item.quantity }})</span>
          </h3>
        </b-col>
        <b-col cols="auto">
          <h3 class="m-0 text-right">{{ $n(item.subtotal, 'currency') }}</h3>
          <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('dp.generic.remove') }}</b-button>
        </b-col>
      </b-row>
      <hr v-if="!last" />

      <div v-if="last && ['LICENCE', 'LATE_FEE'].includes(item.product.type)">
        <b-row>
          <b-col>
            <hr />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <h3 class="m-0 pr-2 pl-4 font-weight-bold">{{ $t('views.basket.licenseTotal') }}</h3>
          </b-col>
          <b-col>
            <h3 class="m-0 text-right">{{ $n(licensingTotal, 'currency') }}</h3>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else-if="'PET_TRACKING_DEVICE' === item.product.type" class="product pl-1 pl-lg-2 pr-1">
      <PetTrackingDeviceProduct :item="item" @remove-item="removeThisItem" />
      <hr class="my-2" />
      <product v-for="childItem in item.children" :key="childItem.id" :item="childItem" child remove />
      <hr v-if="!last" class="hr-lg" />
    </div>
    <div v-else-if="'SUBSCRIPTION' === item.product.type && item.product.productSubType === 'MEMBERSHIP' " class="product pl-1 pl-lg-2 pr-1">
      <MembershipSubscriptionProduct
          :item="item"
          :switching="changeBillingInterval.loading && changeBillingInterval.itemId === item.id"
          :switch-error="changeBillingInterval.error && changeBillingInterval.itemId === item.id"
          :requires-acknowledgement="requiresAcknowledgement"
          :acknowledged="acknowledged"
          :acknowledgement-error="acknowledgementError"
          @remove-item="removeThisItem"
          @change-billing-interval="$emit('change-billing-interval', $event)"
          @acknowledgement-changed="$emit('acknowledgement-changed', $event)"
      />
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div v-else-if="['PET_TAG', 'DESIGNER_TAG'].includes(item.product.type)" class="tag-product product pl-1 pl-lg-2 pr-1 my-3">
      <b-row no-gutters align-v="start">
        <b-col cols="auto">
          <b-link :href="productSelectionLink" :aria-label="item.product.name">
            <b-img
              v-if="item.product.image"
              :src="getImage(item.product.image.original)"
              alt=""
              class="d-none d-md-block"
              width="90px"
              height="90px"
            />
            <b-img
              v-if="item.product.image"
              :src="getImage(item.product.image.original)"
              alt=""
              class="d-block d-md-none"
              width="60px"
              height="60px"
            />
          </b-link>
        </b-col>
        <b-col class="ml-2">
          <b-row no-gutters align-v="start" class="justify-content-between">
            <b-col>
              <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 product-name mb-1">
                <span class="mr-1" v-html="tagProductName"></span>
                <span
                  v-if="item.orderItemBundle && item.orderItemBundle.badge"
                  :style="{ color: item.orderItemBundle.badge.color, backgroundColor: item.orderItemBundle.badge.backgroundColor }"
                  class="badge px-2 py-1"
                >
                  {{ item.orderItemBundle.badge.text }}
                </span>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0">{{ $t('dp.generic.size') }}: {{ size(item.product.size) }}</component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0" hidden
                >Color: {{ item.product.color ? item.product.color : 'N/A' }}</component
              >
              <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0">{{ $t('components.product.splitRing') }}</component>
            </b-col>
            <b-col cols="auto">
              <h3 class="m-0 text-right">
                <span v-if="isItemFree">{{ $t('components.totals.free') }}</span>
                <template v-else>
                  <span
                    :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }"
                  >
                    {{ $n(item.product.price, 'currency') }}
                  </span>
                  <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                    <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
                    <span v-else>{{ $t('components.totals.free') }}</span>
                  </span>
                </template>
              </h3>
              <b-button
                v-if="edit && item.product.style && item.product.style.code !== 'DYOT'"
                variant="link"
                class="m-0 p-0 text-right"
                block
                :href="editSelectionLink"
                >edit</b-button
              >
              <b-button
                v-if="remove || (item.product.style && item.product.style.code === 'DYOT')"
                variant="link"
                class="m-0 p-0 text-right"
                block
                @click="removeThisItem"
                >{{ $t('dp.generic.remove') }}</b-button
              >
            </b-col>
          </b-row>
          <product :item="item" child personalization remove @remove-bundle="$emit('remove-bundle')" @addChildItem="onAddChildItem({ ...$event, parentItem: item })" />
          <product
            v-for="childItem in childItems"
            :key="childItem.id"
            :item="childItem"
            child
            remove
            @remove-bundle="$emit('remove-bundle')"
            @addChildItem="onAddChildItem({ ...$event, parentItem: item })"
          />
        </b-col>
      </b-row>
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div v-else-if="['COLLAR'].includes(item.product.type)" class="pet-products product pl-2 pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto">
          <b-link :href="productSelectionLink" :aria-label="item.product.name">
            <b-img v-if="item.product.image" :src="getImage(item.product.image.original)" alt="" class="img-border product-image" />
          </b-link>
        </b-col>
        <b-col>
          <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 pl-3 pr-3 product-name mb-1" v-text="item.product.name" />
          <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0 pl-3 pr-3">
            Color: {{ item.product.color ? item.product.color : 'N/A' }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0 pl-3 pr-3">{{ $t('dp.generic.size') }}: {{ size(item.product.size) }}</component>
        </b-col>
        <b-col :cols="isSmallScreen ? 12 : 'auto'">
          <h3 class="m-0 text-right" :class="{ 'mt-2': isSmallScreen }">
            <span :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
              {{ $n(item.product.price, 'currency') }}
            </span>
            <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
              <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
              <span v-else>{{ $t('components.totals.free') }}</span>
            </span>
          </h3>
          <b-button variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('dp.generic.remove') }}</b-button>
        </b-col>
      </b-row>
      <product v-for="childItem in item.children" :key="childItem.id" :item="childItem" child remove />
      <product v-if="item.customization || item.customTagOrderInfo" :item="item" child personalization remove />
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div v-else-if="additional" class="additional-product product pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto" class="pl-2">
          <b-link :href="productSelectionLink" :aria-label="item.product.name">
            <b-img v-if="item.product.image" :src="getImage(item.product.image.original)" alt="" class="img-border product-image" />
          </b-link>
        </b-col>
        <b-col>
          <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 pl-3 pr-3 product-name mb-1" v-text="item.product.name" />
          <component
            :is="isSmallScreen ? 'h5' : 'h4'"
            v-if="item.product && ['COLLAR', 'LEASH', 'PET_ESSENTIALS'].includes(item.product.type) && item.product.color"
            class="m-0 pl-3 pr-3"
          >
            Color: {{ item.product.color }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.product && ['COLLAR'].includes(item.product.type)" class="m-0 pl-3 pr-3">
            Size: {{ size(item.product.size) }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.product && ['LEASH'].includes(item.product.type)" class="m-0 pl-3 pr-3">
            Length: {{ item.product.length }}
          </component>
          <component
            :is="isSmallScreen ? 'h5' : 'h4'"
            v-if="item.product && ['PET_ESSENTIALS'].includes(item.product.type) && item.product.size"
            class="m-0 pl-3 pr-3"
          >
            Size: {{ petEssentialsSize(item.product.size) }}
          </component>
          <div v-if="!isSmallScreen && item.product && ['PET_ESSENTIALS'].includes(item.product.type)" class="mt-1 ml-3">
            <span style="border: 1px solid lightgrey; border-radius: 8px; padding: 2px 10px 2px 10px">
              <span class="text-light font-weight-bold" style="cursor: pointer" @click="decrementQty()">-</span>
              <span class="text-dark px-3">{{ item.product.quantity }}</span>
              <span class="text-light font-weight-bold" style="cursor: pointer" @click="incrementQty(item)">+</span>
            </span>
          </div>
        </b-col>
        <b-col :cols="isSmallScreen ? 12 : 'auto'" :class="isSmallScreen ? 'd-flex align-items-center mt-2' : ''">
          <div v-if="isSmallScreen && item.product && ['PET_ESSENTIALS'].includes(item.product.type)" class="ml-2">
            <span style="border: 1px solid lightgrey; border-radius: 8px; padding: 6px 20px 6px 20px">
              <span class="text-light font-weight-bold ml-0 mr-auto" style="cursor: pointer" @click="decrementQty()">-</span>
              <span class="text-dark px-4">{{ item.product.quantity }}</span>
              <span class="text-light font-weight-bold mr-0 ml-auto" style="cursor: pointer" @click="incrementQty(item)">+</span>
            </span>
          </div>
          <div class="ml-auto">
            <h3
              class="m-0 text-right"
              :class="{ 'mt-2': isSmallScreen && (!item.product || !['PET_ESSENTIALS'].includes(item.product.type)) }"
            >
              <span
                :style="{
                  textDecoration: Number(item.product.totalQtyPrice) !== Number(item.product.totalQtyDiscountedPrice) ? 'line-through' : '',
                }"
              >
                {{ $n(item.product.totalQtyPrice, 'currency') }}
              </span>
              <span v-if="Number(item.product.totalQtyPrice) !== Number(item.product.totalQtyDiscountedPrice)" class="ml-1">
                <span v-if="Number(item.product.totalQtyDiscountedPrice) > 0">
                  {{ $n(item.product.totalQtyDiscountedPrice, 'currency') }}
                </span>
                <span v-else>{{ $t('components.totals.free') }}</span>
              </span>
            </h3>
            <b-button
              v-if="remove"
              variant="link"
              class="m-0 p-0 text-right"
              block
              @click="removeThisItem({ quantity: Number(item.product.quantity) || 1 })"
              >{{ $t('dp.generic.remove') }}</b-button
            >
          </div>
        </b-col>
      </b-row>
      <product v-for="childItem in item.children" :key="childItem.id" :item="childItem" child remove />
      <product v-if="item.customization" :item="item" child personalization />
      <hr v-if="!last" />
    </div>
    <div v-else-if="walletCard" class="wallet-card-product product pl-1 pl-lg-2 pr-1">
      <b-row no-gutters align-v="start">
        <b-col cols="auto">
          <b-img
            v-if="item.product.image"
            :src="getImage(item.product.image.original)"
            alt=""
            class="d-none d-md-block img-border"
            width="90px"
            height="90px"
          />
          <b-img
            v-if="item.product.image"
            :src="getImage(item.product.image.original)"
            alt=""
            class="d-block d-md-none img-border"
            width="60px"
            height="60px"
          />
        </b-col>
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between" :class="!isSmallScreen ? ' my-3' : ''">
            <b-col class="ml-2">
              <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 product-name">
                <span class="mr-1">{{ $t('views.basket.petIdentificationCard') }}</span>
                <span
                  v-if="item.orderItemBundle && item.orderItemBundle.badge"
                  :style="{ color: item.orderItemBundle.badge.color, backgroundColor: item.orderItemBundle.badge.backgroundColor }"
                  class="badge px-2 py-1"
                >
                  {{ item.orderItemBundle.badge.text }}
                </span>
              </component>
            </b-col>
            <b-col cols="auto">
              <h3 class="m-0 text-right">
                <span
                  :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }"
                >
                  {{ $n(item.product.price, 'currency') }}
                </span>
                <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                  <span v-if="Number(item.subtotal - item.discount) > 0">
                    {{ $n(item.subtotal - item.discount, 'currency') }}
                  </span>
                </span>
              </h3>
              <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('dp.generic.remove') }}</b-button>
            </b-col>
          </b-row>
          <product
            v-for="childItem in item.children"
            :key="childItem.id"
            class="ml-2"
            :item="childItem"
            child
            remove
            wallet-card
            :wallet-card-price="item.product.price"
          />
        </b-col>
      </b-row>
      <hr v-if="!last" class="hr-lg" />
    </div>
    <automated-discount-notice v-if="showAutomatedDiscountNotice && item.automatedDiscountState === 'APPLIED'" :label="automatedDiscountLabel" />
    <div ref="confirmationModal"></div>
  </b-overlay>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { getImage } from '@/utils';
import {
  DpBaseInput as DpInput,
  DpVsTagExpirationDateMixin,
  DpConfirmationModal,
  DpHomeSafeBrandingMixin,
  DpSurveySubscriptionModal,
  DpShouldShowSurvey,
  DP_MEMBERSHIP_REMOVAL_SURVEY_URL,
  DpAutomatedDiscountNotice as AutomatedDiscountNotice,
  DpAutomatedDiscountLabelArgs,
} from '@docupet/component-library';
import Product from '@/components/basket/Product.vue';
import { CookieMixins } from '@/mixins/cookie';
import PetTrackingDeviceSubscriptionProduct from './Products/PetTrackingDeviceSubscriptionProduct.vue';
import PetTrackingDeviceProduct from './Products/PetTrackingDeviceProduct.vue';
import MembershipSubscriptionProduct from "@/components/basket/Products/MembershipSubscriptionProduct.vue";

export default {
  name: 'Product',
  components: {
    PetTrackingDeviceSubscriptionProduct,
    PetTrackingDeviceProduct,
    MembershipSubscriptionProduct,
    AutomatedDiscountNotice,
    Product,
    DpInput,
    // eslint-disable-next-line vue/no-unused-components
    DpConfirmationModal,
    // eslint-disable-next-line vue/no-unused-components
    DpSurveySubscriptionModal,
  },
  mixins: [CookieMixins, DpVsTagExpirationDateMixin, DpHomeSafeBrandingMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    last: {
      type: Boolean,
      required: false,
      default: false,
    },
    child: {
      type: Boolean,
      required: false,
      default: false,
    },
    personalization: {
      type: Boolean,
      required: false,
      default: false,
    },
    additional: {
      type: Boolean,
      required: false,
      default: false,
    },
    vs: {
      type: Boolean,
      required: false,
      default: false,
    },
    noNewTag: {
      type: Boolean,
      required: false,
      default: false,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    licensingTotal: {
      type: [Number, String],
      required: false,
      default: 0.00,
    },
    walletCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    walletCardPrice: {
      type: [Number, String],
      required: false,
      default: 0.00,
    },
    requiresAcknowledgement: {
      type: Boolean,
      required: false,
      default: false,
    },
    acknowledged: {
      type: Boolean,
      required: false,
      default: false,
    },
    acknowledgementError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      addPersonalization: false,
      personalizationLoading: false,
      personalizationName: '',
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    showAutomatedDiscountNotice() {
      if (this.personalization) {
        return false;
      }

      return !this.child || this.item?.parent?.automatedDiscountState !== 'APPLIED';
    },
    automatedDiscountLabel() {
      return this.$t(...DpAutomatedDiscountLabelArgs(this.item, 'components.product.automatedDiscountLabel'));
    },
    ...mapState({
      removeItem: (state) => state.order.removeItem,
      addItem: (state) => state.order.addItem,
      changeBillingInterval: (state) => state.order.changeBillingInterval,
      orderId: (state) => state.orderId,
      cityId: (state) => state.cityId,
      order: (state) => state.order.order,
      locale: (state) => state.locale,
      glowTagProducts: (state) => state.product?.glowTagProducts,
      connectorProducts: (state) => state.product?.connectorProducts,
    }),
    tagProductName() {
      return this.formatHomeSafeText(this.item?.product?.name);
    },
    productSelectionLink() {
      const baseURL = `${window.BASE_URL}/${this.locale}/${this.orderId ? `order/${this.orderId}/` : ''}store`;
      switch (this.item.product.type) {
        case 'DESIGNER_TAG':
          if (this.item?.product?.style?.id) {
            return `${baseURL}/tags/style/${this.item?.product?.style?.id}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'COLLAR':
          if (this.item?.product?.style?.productGroups?.[0]?.id) {
            return `${baseURL}/collars/style/${this.item?.product?.style?.productGroups?.[0]?.id}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'LEASH':
          if (this.item?.product?.style?.productGroups?.[0]?.id) {
            return `${baseURL}/leashes/style/${this.item?.product?.style?.productGroups?.[0]?.id}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'PET_ESSENTIALS':
          if (this.item?.product?.style?.id && this.item?.product?.style?.productGroups?.[0]?.id) {
            return `${baseURL}/essentials/group/${this.item?.product?.style?.productGroups?.[0]?.id}/style/${this.item?.product?.style?.id}`;
          }
        // eslint-disable-next-line no-fallthrough
        default:
          return 'javascript:void(0)';
      }
    },
    editSelectionLink() {
      return this.orderId && this.item?.product?.style?.id
        ? `${window.BASE_URL}/${this.locale}/order/${this.orderId}/store/tags/pet/${this.item?.group?.pet?.id}/style/${this.item?.product?.style?.id}?etid=${this.item?.id}`
        : 'javascript:void(0)';
    },
    poPrimaryPhone() {
      return (
        this.order?.petOwner?.primaryPhone ||
        this.order?.city?.customerService?.phoneNumber?.toString()?.replaceAll('-', '')?.substring(1) ||
        ''
      );
    },
    childItems() {
      if (this.child) return;
      let hasGlowTag = false;
      let hasConnector = false;
      let hasKeyChain = !(Number(this.item?.product?.keyChainPrice) > 0);
      const childItems = [...this.item?.children];
      childItems?.forEach((child) => {
        if (child?.product?.type === 'CONNECTOR' && child.product?.id !== '207') {
          hasConnector = true;
        }
        if (['3284', '3290', '3291'].includes(child?.product?.id)) {
          hasGlowTag = true;
        }
        if (child?.keyChain) {
          hasKeyChain = true;
        }
      });
      if (hasConnector && hasGlowTag && hasKeyChain) return childItems;
      if (!hasConnector && this.connectorProducts?.length) {
        const secureClipConnector = this.connectorProducts?.find((p) => p.name === 'Secure Clip');
        childItems.push({
          id: null,
          product: secureClipConnector,
        });
      }
      if (
        !hasGlowTag &&
        this.glowTagProducts &&
        (!this.item?.product?.laserPrinterJig?.shape || this.item?.product?.laserPrinterJig?.shape === 'RND')
      ) {
        const glowTagProductId = this.getGlowTagProductId();
        const glowTagProduct = this.glowTagProducts?.[`Product_${glowTagProductId}`];
        if (glowTagProduct?.id && glowTagProduct.status !== 'O') {
          childItems.push({
            id: null,
            product: glowTagProduct,
          });
        }
      }
      if (!hasKeyChain) {
        childItems.push({
          id: null,
          product: this.item?.product,
          keyChain: true,
        });
      }
      return childItems;
    },
    isSmallScreen() {
      return window.innerWidth < 450;
    },
    itemPersonalizationTitle() {
      return this.getPersonalizationAddon?.title;
    },
    itemPersonalizationPrice() {
      return this.$n(this.getPersonalizationAddon?.retailPrice || this.item?.product?.personalization?.price, 'decimal');
    },
    itemPersonalizationDiscountedPrice() {
      return this.$n(this.getPersonalizationAddon?.discountPrice, 'decimal');
    },
    isItemPersonalizationDiscounted() {
      return !!this.getPersonalizationAddon?.isDiscounted
        || Number(this.item?.customization) === 0;
    },
    getPersonalizationAddon() {
      return this.item?.addons?.find((addon) => addon.type === 'personalization');
    },
    isItemFree() {
      return Number(this.item.subtotal) === 0;
    },
  },
  created() {
    window.addEventListener('resize', this.windowResize);
  },
  methods: {
    getImage,
    decrementQty() {
      this.removeThisItem({ quantity: 1 });
    },
    incrementQty(item) {
      if (this.order && this.order.id && this.order.petOwner && this.order.petOwner.id) {
        this.onAddChildItem({ item });
      } else {
        this.$store.dispatch('order/addLocalItem', {
          data: [
            {
              style: item?.product?.style?.id,
              productId: item?.product?.id,
              color: item?.product?.color || null,
              size: item?.product?.size || null,
            },
          ],
        });
      }
    },
    size(str) {
      if (str == '0/T') return 'Extra Small';
      else if (str == '1/S') return 'Small';
      else if (str == '2/M') return 'Medium';
      else if (str == '3/L') return 'Large';
      else if (str == '4/X') return 'Extra Large';
      else 'N/A';
    },
    petEssentialsSize(str) {
      if (str == 'xs') return 'Extra Small';
      else if (str == 's') return 'Small';
      else if (str == 'm') return 'Medium';
      else if (str == 'l') return 'Large';
      else if (str == 'xl') return 'Extra Large';
      else 'N/A';
    },
    emitAddChildItem() {
      if (this.child && this.personalization && this.addPersonalization && this.personalizationName) {
        this.personalizationLoading = true;
      }
      this.$emit('addChildItem', {
        item: this.item,
        child: this.child,
        personalization: this.personalization,
        personalizationName: !this.addPersonalization ? this.item?.group?.pet?.name?.substr(0, 9) : this.personalizationName,
        personalizationPhone: this.poPrimaryPhone,
      });
    },
    async onAddChildItem({ item, child, personalization, parentItem, personalizationName, personalizationPhone }) {
      let data = await this.splitSetBasket();
      const discountCode = await this.getBasketCodeCookie();
      if (!this.orderId) {
        if (child) {
          const index = data.findIndex((d) => d.productId == parentItem.product?.id);
          if (index !== -1) {
            if (personalization) {
              data[index].personalize.selected = true;
              data[index].personalize.name = personalizationName;
              data[index].personalize.phone = personalizationPhone;
            } else {
              if (item.product?.type === 'CONNECTOR') {
                data[index].connector = item.product?.id;
                data[index].isSplitRingConnector = false;
              } else if (item.keyChain) {
                data[index].keyChain = true;
              } else {
                data[index].otherProductIds?.push(item.product?.id);
              }
            }
          }
        }
      }

      this.$store
        .dispatch('order/addItemOrPersonalization', {
          vm: this,
          orderId: this.orderId,
          itemId: parentItem?.id,
          productDetails: {
            parentId: parentItem?.id,
            productId: item?.product?.id,
            keyChain: item?.keyChain,
          },
          personalization: personalization ? { name: personalizationName, phone: personalizationPhone } : false,
          data,
          discountCode,
          changingDiscount: false,
        })
        .then(() => {
          if (!this.orderId) this.setBasketCookie(data);

          if (window?.dataLayer) {
            window?.dataLayer?.push({
              ecommerce: null,
            });
            const items = [];
            if (parentItem || personalization) {
              const _itemData = {
                quantity: 1,
                coupon: this.order?.discount?.code || '',
                currency: `${this.order?.city?.country || 'US'}D`,
                item_list_id: parentItem?.product?.style?.id || '',
                item_list_name: parentItem?.product?.style?.code?.toUpperCase() || '',
              };
              if (personalization) {
                items.push({
                  ..._itemData,
                  item_id: `${parentItem?.product?.type?.toUpperCase()}_PERSONALIZATION`,
                  item_name: `${parentItem?.product?.type?.toUpperCase()}_PERSONALIZATION`,
                  item_category: 'PERSONALIZATION',
                  price: Number(parentItem?.product?.personalization?.price || 0).toFixed(2),
                });
              } else {
                const _childData = {
                  ..._itemData,
                  item_id: item?.product?.id || '',
                  item_name: item?.product?.name?.toUpperCase() || '',
                  item_category: item?.product?.type?.toUpperCase() || '',
                  price: Number(item?.product?.price || 0).toFixed(2),
                };
                if (['OTHER'].includes(item?.product?.type) || (item?.product?.type === 'CONNECTOR' && item?.product?.id !== '207')) {
                  items.push(_childData);
                }
                if (item?.product?.type === 'DESIGNER_TAG' && item?.keyChain) {
                  items.push({
                    ..._childData,
                    item_id: `${item?.product?.id}_MATCHING_KEYCHAIN`,
                    item_name: `${item?.product?.id}_MATCHING_KEYCHAIN`,
                    item_category: 'MATCHING_KEYCHAIN',
                    price: Number(item?.product?.keyChainDiscountedPrice || item?.product?.keyChainPrice || 0).toFixed(2),
                  });
                }
              }
            }
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                items: items,
                currency: `${this.order?.city?.country || 'US'}D`,
                value: Number(items?.reduce((p, c) => p + Number(c.price), 0)).toFixed(2),
              },
              location: 'user_basket',
            });
          }
        })
        .catch(async () => {
          if (!this.orderId) await this.setBasketCookie(await this.splitSetBasket());
        });
    },
    async removeThisItem({ quantity = 1, confirm = false }) {
      if (this.item?.orderItemBundle) {
        if (confirm === false) {
          this.showRemoveBundleItemConfirmationModal(() => this.removeThisItem({ quantity, confirm: true }));
          return;
        }
        this.$emit('remove-bundle');
      }
      if (this.item.product.type === 'PET_TRACKING_DEVICE') {
        this.$emit('remove-pet-tracker');
      }
      if (this.order.id) {
        await this.$store.dispatch(
          this.personalization ? 'order/removePersonalization' : quantity > 1 ? 'order/removeItemsByProduct' : 'order/removeItem',
          { itemId: this.item.id, productId: this.item.product.id, quantity }
        );
      } else {
        let data = await this.splitSetBasket();
        const discountCode = await this.getBasketCodeCookie();

        if (this.child) {
          if (this.personalization) {
            let index = data.findIndex((d) => {
              return (
                d.productId == this.item?.product?.id &&
                !!d.personalize.selected == !!this.item?.customTagOrderInfo &&
                (!d.personalize.selected ||
                  (d.personalize?.name == this.item?.customTagOrderInfo?.name &&
                    d.personalize?.phone == this.item?.customTagOrderInfo?.phone))
              );
            });
            if (index != -1) {
              data[index].personalize.selected = false;
            }
          } else {
            if (this.item?.product?.type === 'CONNECTOR') {
              let index = data.findIndex((d) => {
                return (
                  d.connector == this.item?.product.id &&
                  this.item?.parent &&
                  d.productId == this.item?.parent.product.id &&
                  !!d.personalize.selected == !!this.item?.parent.customTagOrderInfo
                );
              });
              if (index != -1) {
                data[index].connector = '';
              }
            } else if (this.item?.keyChain) {
              let index = data.findIndex((d) => {
                return (
                  this.item.parent &&
                  d.productId == this.item.parent.product.id &&
                  !!d.personalize.selected == !!this.item.parent.customTagOrderInfo &&
                  !!d.keyChain == !!this.item.keyChain
                );
              });
              if (index != -1) {
                data[index].keyChain = false;
              }
            } else {
              let index = data.findIndex((d) => {
                return (
                  d.otherProductIds.includes(this.item?.product.id) &&
                  this.item?.parent &&
                  d.productId == this.item?.parent.product.id &&
                  !!d.personalize.selected == !!this.item?.parent.customTagOrderInfo
                );
              });
              if (index != -1) {
                data[index].otherProductIds?.splice(
                  data[index].otherProductIds?.findIndex((id) => id == this.item?.product.id),
                  1
                );
              }
            }
          }
        } else {
          let q = quantity;
          while (q > 0) {
            data.splice(
              data.findIndex((d) => d.productId === this.item.product.id),
              1
            );
            q--;
          }
        }

        this.$store
          .dispatch('order/createLocalOrder', { vm: this, cityId: this.cityId, data, discountCode, changingDiscount: false })
          .then(() => this.setBasketCookie(data));
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          ecommerce: null,
        });
        const items = [];
        const _itemData = {
          quantity: 1,
          coupon: this.order?.discount?.code || '',
          currency: `${this.order?.city?.country || 'US'}D`,
          item_list_id: this.item?.product?.style?.id || '',
          item_list_name: this.item?.product?.style?.code?.toUpperCase() || '',
        };
        if (this.item?.parent || this.personalization) {
          if (this.personalization && (this.item?.customTagOrderInfo || this.item?.customization)) {
            items.push({
              ..._itemData,
              item_id: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_name: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_category: 'PERSONALIZATION',
              price: Number(this.item?.customization || 0).toFixed(2),
            });
          } else {
            const _childData = {
              ..._itemData,
              item_id: this.item?.product?.id || '',
              item_name: this.item?.product?.name?.toUpperCase() || '',
              item_category: this.item?.product?.type?.toUpperCase() || '',
              price: Number(this.item?.subtotal || 0).toFixed(2),
            };
            if (
              ['OTHER'].includes(this.item?.product?.type) ||
              (this.item?.product?.type === 'CONNECTOR' && this.item?.product?.id !== '207')
            ) {
              items.push(_childData);
            }
            if (this.item?.product?.type === 'DESIGNER_TAG' && this.item?.keyChain) {
              items.push({
                ..._childData,
                item_id: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_name: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_category: 'MATCHING_KEYCHAIN',
              });
            }
          }
        } else {
          this.item?.children?.forEach((child) => {
            const _childData = {
              ..._itemData,
              item_id: child.product?.id || '',
              item_name: child.product?.name?.toUpperCase() || '',
              item_category: child.product?.type?.toUpperCase() || '',
              price: Number(child.subtotal || 0).toFixed(2),
            };
            if (['OTHER'].includes(child.product?.type) || (child.product?.type === 'CONNECTOR' && child.product?.id !== '207')) {
              items.push(_childData);
            }
            if (child.product?.type === 'DESIGNER_TAG' && child.keyChain) {
              items.push({
                ..._childData,
                item_id: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_name: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_category: 'MATCHING_KEYCHAIN',
              });
            }
          });
          if (this.item?.customTagOrderInfo || this.item?.customization) {
            items.push({
              ..._itemData,
              item_id: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_name: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_category: 'PERSONALIZATION',
              price: Number(this.item?.customization || 0).toFixed(2),
            });
          }
          items.push({
            ..._itemData,
            item_id: this.item?.product?.id || '',
            item_name: this.item?.product?.name?.toUpperCase() || '',
            item_category: this.item?.product?.type?.toUpperCase() || '',
            price: Number(this.item?.subtotal || 0).toFixed(2),
          });
        }
        window.dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            items: items,
            currency: `${this.order?.city?.country || 'US'}D`,
            value: Number(items?.reduce((p, c) => p + Number(c.price), 0)).toFixed(2),
          },
          location: 'user_basket',
        });
      }

      this.maybeShowMembershipRemovalSurvey();
    },
    isMembershipItem() {
      return (
        this.item?.product?.type === 'SUBSCRIPTION' && this.item?.product?.productSubType === 'MEMBERSHIP'
      );
    },
    maybeShowMembershipRemovalSurvey() {
      if (!this.isMembershipItem()) {
        return;
      }
      const shouldShow = DpShouldShowSurvey({
        enabled: this.$store.getters.getMembershipRemovalSurvey,
      });
      if (shouldShow) {
        this.showMembershipRemovalSurveyModal();
      }
    },
    showMembershipRemovalSurveyModal() {
      const survey = new Vue({
        render: (h) =>
          h(DpSurveySubscriptionModal, {
            props: {
              surveyUrl: DP_MEMBERSHIP_REMOVAL_SURVEY_URL,
              title: this.$t('dp.survey.membershipRemoval.title'),
              closeLabel: this.$t('dp.survey.membershipRemoval.close'),
              show: true,
            },
            on: {
              close: () => {
                survey.$destroy();
                if (survey.$el && survey.$el.parentNode) {
                  survey.$el.parentNode.removeChild(survey.$el);
                }
              },
            },
          }),
      }).$mount();

      document.body.appendChild(survey.$el);
    },
    getGlowTagProductId() {
      if (!this.item?.product?.color) return null;
      const GLOW_TAG_PRODUCT = {
        LG: '3284',
        SM_ALM: '3290',
        SM: '3291',
      };
      return this.item?.product?.size === '1/S'
        ? (this.item?.product?.material?.material === 'ALM' || (this.item?.product?.laserPrinterJig?.material === 'ALM'))
          ? GLOW_TAG_PRODUCT.SM_ALM
          : GLOW_TAG_PRODUCT.SM
        : GLOW_TAG_PRODUCT.LG;
    },
    showRemoveBundleItemConfirmationModal(confirmCallback) {
      const modalContainer = this.$refs.confirmationModal;

      if (modalContainer.childNodes.length) {
        modalContainer.childNodes.forEach((node) => node.remove());
      }

      new Vue({
        render: (h) => {
          let petName = this.item?.group?.pet?.name;
          let messageText = this.$t('components.removeBundleItemConfirmation.messageNoPet')

          if (petName) {
            messageText = this.$t('components.removeBundleItemConfirmation.message', {
              petName,
            })
          }

          return h(DpConfirmationModal, {
            props: {
              id: `remove-item-confirmation-${this.petId}`,
              title: this.$t('components.removeBundleItemConfirmation.title'),
              message: messageText,
              cancelButtonText: this.$t('components.removeBundleItemConfirmation.cancelButtonText'),
              confirmButtonText: this.$t('components.removeBundleItemConfirmation.confirmButtonText'),
              show: true,
            },
            on: {
              confirm: () => confirmCallback(),
              cancel: () => modalContainer.childNodes.forEach((node) => node.remove()),
            },
          });
        },
      }).$mount(modalContainer);
    },
  },
  windowResize() {
    this.windowWidth = window.innerWidth;
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
::v-deep img {
  object-fit: contain;
}
::v-deep .img-border {
  border: solid 1px $dp-gray-4;
}
::v-deep .hr-lg {
  border-top: 2px solid $dp-gray-3;
}
::v-deep h5,
::v-deep .h5 {
  font-size: 0.9rem;
}
::v-deep .product {
  & h3,
  .product-name {
    color: $dp-gray-7;
  }
  .product-image {
    width: 90px;
    height: 90px;
    @media (max-width: 350px) {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
